import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CHAT_RESPONSE } from '../actionTypes/actionTypes';

const initialState: any = {
    responses: [],
};

const chatSlice = createSlice({
    name: CHAT_RESPONSE,
    initialState,
    reducers: {
        updateResponses: (state, action: PayloadAction<any>) => {
            const { payload } = action;
            state.responses.push(payload);
        },
        resetResponses: (state) => {
            state.responses = [];
        },
    },
});

export const { updateResponses, resetResponses } = chatSlice.actions;
export default chatSlice.reducer;
